import {createReducer} from 'react-native-offline';
import {find, isEqual} from 'lodash';

function findMatchedAction(action: any, actionQueue: any) {
  return find(actionQueue, (queued: any) => {
    return isEqual(queued.meta.baseAction, action.meta.baseAction);
  });
}

export const network = createReducer(findMatchedAction);
